var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "displaysettings absolute top-right fs-3 zi-100" },
    [
      _c("div", { staticClass: "flex-level pb-3 bb-1" }, [
        _c("h3", { staticClass: "flex m-0" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Gestion & ordre des colonnes")))
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "close-btn",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.$store.commit(
                  _vm.listinghash + "/hideDisplay",
                  "columns"
                )
              }
            }
          },
          [_vm._v("\n            ×\n        ")]
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "my-3 gray-60" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Modifiez l'ordre des labels visibles pour organiser votre tableau comme vous le désirez."
              )
            ) +
            "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Gérez les informations visibles dans votre tableau en cochant les colonnes que vous souhaitez afficher."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-level flex-top columns-sortable bb-1" }, [
        _c("div", { staticClass: "flex pr-3 hp-10" }, [
          _c("h4", { staticClass: "mt-0" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Colonnes visibles")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "column-list-container ovy-auto" },
            [
              _vm.mainColumn
                ? _c("div", { staticClass: "p-1 pl-3 flex-level" }, [
                    _c("div", { staticClass: "flex" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.mainColumn.label) +
                          "\n                    "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "draggable",
                {
                  attrs: {
                    options: { group: "columns", draggable: ".itm-column" }
                  },
                  model: {
                    value: _vm.activeColumns,
                    callback: function($$v) {
                      _vm.activeColumns = $$v
                    },
                    expression: "activeColumns"
                  }
                },
                [
                  _vm._l(_vm.activeColumns, function(column) {
                    return [
                      !column.isMain
                        ? _c(
                            "div",
                            {
                              key: "displayed_" + column.name,
                              staticClass: "p-1 pl-3 flex-level",
                              class: {
                                "itm-column cursor-move": !column.isMain
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  column.name.startsWith("cf_")
                                    ? _c(
                                        "badge",
                                        {
                                          attrs: {
                                            dot: "",
                                            inline: "",
                                            tooltip: "",
                                            badges: _vm.getBadges(column)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(column.label) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    : _c("span", [_vm._v(_vm._s(column.label))])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "close-btn",
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeDisplay(column)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                ×\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex pl-3 bl-1 hp-10" }, [
          _c("h4", { staticClass: "mt-0" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Colonnes disponibles")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group my-2 prelative" }, [
            _c("div", { staticClass: "form-input wp-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchword,
                    expression: "searchword"
                  }
                ],
                ref: "searchcolumn",
                staticClass: "h-4 wp-10 search_input",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t.__("common.actions.search_column")
                },
                domProps: { value: _vm.searchword },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchword = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.searchword != ""
                ? _c(
                    "a",
                    {
                      staticClass: "close-btn search_clear",
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          _vm.searchword = ""
                        }
                      }
                    },
                    [_vm._v("×")]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "columns_list" },
            _vm._l(_vm.filteredColumns, function(column) {
              return _c(
                "li",
                { key: "available_" + column.name, staticClass: "p-1 pl-0" },
                [
                  _c(
                    "label",
                    { staticClass: "flex-row", attrs: { for: column.name } },
                    [
                      _c("input", {
                        staticClass: "wauto",
                        attrs: {
                          type: "checkbox",
                          disabled: column.isMain,
                          id: column.name
                        },
                        domProps: { checked: column.display },
                        on: {
                          change: function($event) {
                            return _vm.toggleDisplay($event, column)
                          }
                        }
                      }),
                      _vm._v(" "),
                      column.name.startsWith("cf_")
                        ? _c(
                            "badge",
                            {
                              attrs: {
                                dot: "",
                                inline: "",
                                tooltip: "",
                                badges: _vm.getBadges(column)
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(column.label) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _c("span", [_vm._v(_vm._s(column.label))])
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "displaysettings__footer" },
        [
          _c("CompassPlainButton", {
            attrs: {
              label: _vm.$t.__("common.actions.reset_columns"),
              variant: "neutral",
              leftIcon: "revert"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.resetDisplay($event)
              }
            }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.apply") },
            on: { click: _vm.apply }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }